import { IQueryContext } from 'framework/context/IQueryContext';
import { IInventoryItem, IInventoryItemsQueryParams, IQueryResult } from 'gen/ApiClient';
import React from 'react';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IInventoryItem>, IInventoryItemsQueryParams>>(undefined as any);
